function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export class LoaderError extends Error {
  constructor(id, error) {
    super();

    _defineProperty(this, "nativeError", void 0);

    this.message = `Failed to load module ${id}`;
    this.name = 'LoaderError';
    this.nativeError = error;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, LoaderError);
    }
  }

}
export const isLoaderError = error => error instanceof LoaderError;